import { getIn } from 'immutable';



const root = 'clock';
export const getTimeMs = (state) =>
  getIn(state, [root, 'timeMs'], Date.now());

